import React, { useEffect } from 'react'
import * as ReportCategory from './ReportCategory'
import {
  Box, Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle, FormControl, FormControlLabel,
  Grid, Radio, RadioGroup
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import SubmitButton from '../../commonUIComponents/SubmitButton'
import { FormProvider } from 'react-hook-form'
import IconButton from '@mui/material/IconButton'

const CommunityForm = ({ post, comment, methods, onBack, onSubmit, onClose, submitButtonLabel }) => {
  const { handleSubmit } = methods

  useEffect(() => {
    ReportCategory.getReportCategoryList(post?.communityId || comment?.communityId).forEach((category) => {
      if (category.name === methods.watch('category')) {
        methods.setValue('question', category.question)
        methods.setValue('answers', [...category.answers])
      }
    })
  }, [methods.watch('category')])

  const radioGroupOnChangeHandler = (event) => {
    methods.setValue('reason', event.target.value)
    console.log(methods.watch('reason'))
  }

  const ReportReasonRadioGroup = () => {
    return (
      <Grid item xs={12}>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            alignContent: 'center',
            justifyContent: 'flex-start',
            m: -1
          }}
        >
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={methods.watch('reason') ? methods.watch('reason') : null}
              onChange={radioGroupOnChangeHandler}
            >
              {methods.watch('answers')?.map(option => { return <FormControlLabel key={option} value={option} control={<Radio />} label={option} /> })}
            </RadioGroup>
          </FormControl>
        </Box>
      </Grid>
    )
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <IconButton
          aria-label="back"
          onClick={onBack}
          sx={(theme) => ({
            position: 'absolute',
            left: 8,
            top: 10,
            color: theme.palette.grey[500]
          })}
        >
          <ArrowBackIcon />
        </IconButton>
        <DialogTitle sx={{ ml: '1.5rem' }}>Submit a report</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500]
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText>
            {methods.watch('question')}
          </DialogContentText>
          <Grid container spacing={2} sx={{ marginTop: '0.5rem' }}>
            <ReportReasonRadioGroup />
          </Grid>
          <DialogActions>
            {methods.watch('reason')
              ? <SubmitButton buttonLabel={submitButtonLabel} textAlign="right" />
              : <SubmitButton buttonLabel={submitButtonLabel} textAlign="right" disabled={true} />
            }
          </DialogActions>
        </DialogContent>
      </form>
    </FormProvider>
  )
}

export default CommunityForm
